var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCongratulation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12673 12.1844C5.97396 12.338 5.76564 12.4238 5.54914 12.4238C5.33265 12.4238 5.12433 12.338 4.97156 12.1844L0.35905 7.5711C-0.119683 7.09237 -0.119683 6.31626 0.35905 5.83835L0.936635 5.26076C1.41537 4.78203 2.19066 4.78203 2.66939 5.26076L5.54914 8.14051L13.3306 0.35905C13.8093 -0.119683 14.5854 -0.119683 15.0634 0.35905L15.6409 0.936635C16.1197 1.41537 16.1197 2.19147 15.6409 2.66939L6.12673 12.1844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratulation);
export default __webpack_public_path__ + "static/media/congratulation.227f3fd823e2a8d9054ff8647a5916bb.svg";
export { ForwardRef as ReactComponent };